import logoMarkUrl from '@/assets/logo-mark.svg';
import { Brand } from '@/constants/brand';
import { cn } from '@/lib/utils';

export function Logo({ className }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 text-lg font-extrabold tracking-tight text-graphite', className)}>
      <img src={logoMarkUrl} alt="" width="28" height="28" className="size-7 shrink-0" />
      <span>{Brand.name}</span>
    </span>
  );
}